import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { ILessonListItem } from '@lb/api/mylb/interfaces';
import { MD_DIALOG_REF, MDDialogModule, MDIconComponent, MDTagComponent, MDContentBoxComponent } from '@melodic-ui/components';
import { buildLessonTags } from '../../lessons/utils/lesson-tags.util';
import { GradeTagComponent } from '@lb/components/grade-tag/grade-tag.component';
import { RichTextViewComponent } from '@lb/components/rich-text-view';

@Component({
	selector: 'lb-lesson-summary-dialog',
	templateUrl: './lesson-summary-dialog.component.html',
	styleUrl: './lesson-summary-dialog.component.scss',
	standalone: true,
	imports: [CommonModule, MDDialogModule, MDIconComponent, MDTagComponent, MDContentBoxComponent, GradeTagComponent, RichTextViewComponent]
})
export class LessonSummaryDialogComponent {
	private readonly dialogRef = inject(MD_DIALOG_REF);

	lesson = input.required<ILessonListItem>();

	private readonly _now = new Date();

	lessonSummary = computed(() => this.lesson().lessonSummary);

	lessonDate = computed(() =>
		new Date(this.lesson().lessonDate).toLocaleDateString(undefined, {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		})
	);

	lessonTypeIcon = computed(() => {
		switch (this.lesson().lessonTypeID) {
			case 1:
				return 'untitled-ui/general/target-05';
			case 2:
				return 'untitled-ui/media/monitor-01';
			case 3:
				return 'untitled-ui/communication/message-circle-01';
			case 4:
				return 'mylb/bird-outline';
			default:
				return 'untitled-ui/education/book-open-01';
		}
	});

	private readonly _tags = computed(() => buildLessonTags({ lesson: this.lesson(), view: 'instructor', referenceTime: this._now }));

	statusTags = computed(() => this._tags().tags);
	hasTakenAttendance = computed(() => this.lesson().attendanceStatusID != null);

	close(): void {
		this.dialogRef.close(false);
	}

	viewDetails(): void {
		this.dialogRef.close(true);
	}
}
